import styled from "styled-components"

export const Container = styled.div`
  min-height: 100vh;

  background: #f1f0ec;
  color: #000;
`

export const Nav = styled.nav`
  position: sticky;
  top: 0;
  z-index: 2;

  display: flex;
  justify-content: center;

  width: 100%;
  height: 58px;

  background-color: #000;

  @media (min-width: 768px) {
    height: 64px;
  }
`

export const NavInner = styled.div`
  display: flex;
  align-items: center;

  width: 100%;
  max-width: 1280px;

  padding: 0 25px;
`

export const Logo = styled.img`
  display: block;

  width: auto;
  height: 38px;
`

export const Main = styled.main`
  display: flex;
  align-items: center;
  justify-content: center;

  min-height: calc(100vh - 58px);
  padding: 40px 16px;

  text-align: center;

  @media (min-width: 768px) {
    min-height: calc(100vh - 64px);
  }
`

export const Content = styled.div`
  width: 100%;
  max-width: 600px;

  padding: 16px;

  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.25);

  h1 {
    padding-bottom: 16px;

    font-weight: 700;
    font-size: 1.25rem;
    line-height: 1.25;
    text-transform: uppercase;
    letter-spacing: 0.0075em;
  }

  p {
    margin-bottom: 16px;

    font-weight: 400;
    font-size: 0.875rem;
    line-height: 1.43;
    letter-spacing: 0.01071em;
  }

  a {
    color: inherit;
    text-decoration: underline;
  }
`
